import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../dynamicFormBuilder/FormField'
import { GridLayout } from "../../../common/GridLayout";
import { Localization } from "../../../common/Localization";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    Lookup,
} from "devextreme-react/data-grid";
import { FillFilters, FormatPhoneNumber, loadLookupFromDataSource } from '../../../common/Utils'
import { SearchLayout } from './Layout';
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";
import { set } from 'lodash';
import '../../../common/css/searchPage.css';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];






const List = (props) => {
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(true);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const rowId = useRef(null);
    const dataGrid = useRef(null);

    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "48E97387-5D80-449B-8F05-3C43F3228E28";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const initialFormFields = {
        Record: null,
        KeySequence: null,
        CreationDateTime: null,
        CreationUserId: null,
        LastUpdateDateTime: null,
        LastUpdateUserId: null,
        CompanyId: null,
        Module: null,
        RecordType: null,
        RProfile: null,
        ProfileCode: null,
        ItemCode: null,
        RWarehouse: null,
        Description1: null,
        Description2: null,
        RIdentity: null,
        IdentityId: null,
        ROemManufactureId: null,
        OemManufacturerCode: null,
        RDestinationId: null,
        ClassCode: null,
        SubClassCode: null,
        ItemType: null,
        AbcCode: null,
        Status: null,
        StatusReasonCode: null,
        TaxStatus: null,
        Comment: null,
        LocationType: null,
        RLocation: null,
        PhysicalCountCode: null,
        FreightClassCode: null,
        RGlDepartment: null,
        RCajobCode: null,
        InventoryUnitUom: null,
        PiecesPerUnitUom: null,
        PiecesPerUnitQuantity: null,
        UnitsPerPackageUom: null,
        RItemKittCode: null,
        UnitsPerPackageQuantity: null,
        ArTradeDiscountFlag: null,
        PackagesPerShippingUnitUom: null,
        ArTermsDiscountFlag: null,
        PackagesPerShippingUnitQty: null,
        SaleIncrementQuantity: null,
        UnitVolumeUom: null,
        MinimumSalesQuantity: null,
        UnitVolumeQuantity: null,
        UserDefinedComment: null,
        UnitAreaUom: null,
        UnitAreaQuantity: null,
        UnitValueUom: null,
        UnitValueQuantity: null,
        WeightBasisFlag: null,
        NetWeightUom: null,
        NetWeightQuantity: null,
        GrossWeightUom: null,
        RProductCategory: null,
        GrossWeightQuantity: null,
        VendorItemCode: null,
        ReceiptUomDefault: null,
        ReceiptUomMultiple: null,
        ReceiptUomAlternative: null,
        ReceiptPackSize: null,
        ShipmentUomDefault: null,
        ShipmentUomMultiple: null,
        ShipmentUomAlternative: null,
        ShipmentPackSize: null,
        ShipSelection: null,
        StackHeight: null,
        PalletPatternRow: null,
        PalletPatternColumn: null,
        PalletPatternHeight: null,
        PalletSizeCode: null,
        BoxCode: null,
        HazardousFlag: null,
        CareInstructions: null,
        SpecificationCode: null,
        ItemSupcCode: null,
        BomExplosionFlag: null,
        MiscelleanousFeeFlag: null,
        StorageLocationType: null,
        StorageLocationPriorityFlag: null,
        SystemCode: null,
        AssemblyCode: null,
        PartCode: null,
        EmCostBucketNumber: null,
        TlFuelTaxFlag: null,
        TlFuelTaxCode: null,
        DateIntroduced: null,
        DateAvailable: null,
        DateExpiration: null,
        StorageBillingStartDate: null,
        StorageBillingEndDate: null,
        ItemSourceFlag: null,
        ReorderMethodFlag: null,
        ReorderInventoryMinimumQty: null,
        ReorderInventoryMaximumQty: null,
        ReorderMinimumDaysOnHand: null,
        ReorderMaximumDaysOnHand: null,
        ReorderQuantityEoqCalculated: null,
        ReorderQuantityEntered: null,
        ReorderQuantityOrderMultiple: null,
        ReorderSafetyQuantity: null,
        ReorderLeadTime: null,
        CostBasisMethodFlag: null,
        AverageCost: null,
        StandardCost: null,
        RPriceTable: null,
        CorePrice: null,
        MaximumPriceLevelForDiscount: null,
        AnniversaryBillingFlag: null,
        AnniversaryBillingDate: null,
        AnniversaryBillingQuantity: null,
        WarrantyFlag: null,
        WarrantyPeriodTypeFlag: null,
        WarrantyMonths: null,
        WarrantyMeterMiles: null,
        WarrantyMeterHours: null,
        UserDefinedCode1: null,
        UserDefinedCode2: null,
        UserDefinedCode3: null,
        UserDefinedCode4: null,
        UserDefinedCode5: null,
        UserDefinedCode6: null,
        UserDefinedCode7: null,
        UserDefinedCode8: null,
        UserDefinedCode9: null,
        UserDefinedCode10: null,
        UserDefinedReference1: null,
        UserDefinedReference2: null,
        UserDefinedReference3: null,
        UserDefinedReference4: null,
        UserDefinedReference5: null,
        UserDefinedReference6: null,
        UserDefinedReference7: null,
        UserDefinedReference8: null,
        UserDefinedReference9: null,
        UserDefinedReference10: null,
        UserDefinedDate1: null,
        UserDefinedDate2: null,
        UserDefinedDate3: null,
        UserDefinedDate4: null,
        UserDefinedDate5: null,
        UserDefinedDate6: null,
        UserDefinedDate7: null,
        UserDefinedDate8: null,
        UserDefinedDate9: null,
        UserDefinedDate10: null,
        UserDefinedQuantity1: null,
        UserDefinedQuantity2: null,
        UserDefinedQuantity3: null,
        UserDefinedQuantity4: null,
        UserDefinedQuantity5: null,
        UserDefinedQuantity6: null,
        UserDefinedQuantity7: null,
        UserDefinedQuantity8: null,
        UserDefinedQuantity9: null,
        UserDefinedQuantity10: null,
        RGlFund: null,
        ProfileGuid: null,
        LocationClassForwardPick: null,
        LocationClassReplenishment: null,
        LocationClassReserve: null,
        LocationSubclassForwardPick: null,
        LocationSubclassReplenishment: null,
        LocationSubclassReserve: null,
        LocationMaxUnitsForwardPick: null,
        LocationMinUnitsForwardPick: null,
        RLocationPrimaryReplenishment: null,
        RLocationPrimaryReserve: null,
        RLocationBackupForwardPick: null,
        RLocationBackupReplenishment: null,
        RLocationBackupReserve: null,
        LocationMinUnitsReplenishment: null,
        LocationMaxUnitsReplenishment: null,
        PalletReference: null,
        RHazardous: null,
        OnHand: null,
        InOrdered: null,
        OutOrdered: null,
        InReceiving: null,
        OutShipped: null,
        InBackOrder: null,
        OutBackOrder: null,
        InUnavailable: null,
        OutUnavailable: null,
        InFuture: null,
        OutFuture: null,
        Available: null,
        NetAvailable: null,
        RRateSchedule: null,
        PopupMessage: null,
        LastCost: null,
        InventoryQuantitySource: null,
        RBuyer: null,
        RateSource: null,
        RateSelection: null,
        Size1: null,
        Size2: null,
        StorageBilledDateLast: null,
        StorageBilledDateNext: null,
        MsdsFileName: null,
        RAssociateItem: null,
        AssociateDesc: null,
        PriceSource: null,
        PriceMethod: null,
        CalcMethod: null,
        PriceLevelA: null,
        PriceLevelB: null,
        PriceLevelC: null,
        PriceLevelD: null,
        PriceLevelE: null,
        RWarrantyCode: null,
        ManagementSource: null,
        PriceBasis: null,
        RFees: null,
        SubLotUniqueFlag: null,
        RfReceiptValidation: null,
        RfShipmentValidation: null,
        InTransactionNumber: null,
        DateLastReceipt: null,
        AcStandardUnitFactor: null,
        AcStandardWeightFactor: null,
        ItemPayGroup: null,
        RParticipant: null,
        CommissionBasis: null,
        CommissionAmount: null,
        RoundingMethod: null,
        RoundingFactor: null,
        AlternateStandardCost: null,
        AlternateAverageCost: null,
        AlternateLastCost: null,
        PrevStorageBilledDateLast: null,
        PrevStorageBilledDateNext: null,
        RecurringStorage: null,
        WebAccessibility: null,
        OmKitFlag: null,
        PmKitFlag: null,
        WarrantyFlagShipment: null,
        WarrantyMonthsShipment: null,
        CheckMaxDays: null,
        MaxDays: null,
        CheckLotExpiration: null,
        UpdateUomWeight: null,
        AutomaticallyUpdateQuantity: null,
        LocationAvailableDefault: null,
        LocationReasonCodeDefault: null,
        RItemGroup: null,
        ItemSubGroup: null,
        ItemMember: null,
        CheckReceiptDays: null,
        CheckShipmentDays: null,
        RImMandatedFees: null,
        ExpDateBasedOn: null,
        AddToExpDate: null,
        UserDefinedCode11: null,
        UserDefinedCode12: null,
        UserDefinedCode13: null,
        UserDefinedCode14: null,
        UserDefinedCode15: null,
        UserDefinedCode16: null,
        UserDefinedCode17: null,
        UserDefinedCode18: null,
        UserDefinedCode19: null,
        UserDefinedCode20: null,
        UserDefinedDate11: null,
        UserDefinedDate12: null,
        UserDefinedDate13: null,
        UserDefinedDate14: null,
        UserDefinedDate15: null,
        UserDefinedDate16: null,
        UserDefinedDate17: null,
        UserDefinedDate18: null,
        UserDefinedDate19: null,
        UserDefinedDate20: null,
        UserDefinedQuantity11: null,
        UserDefinedQuantity12: null,
        UserDefinedQuantity13: null,
        UserDefinedQuantity14: null,
        UserDefinedQuantity15: null,
        UserDefinedQuantity16: null,
        UserDefinedQuantity17: null,
        UserDefinedQuantity18: null,
        UserDefinedQuantity19: null,
        UserDefinedQuantity20: null,
        UserDefinedReference11: null,
        UserDefinedReference12: null,
        UserDefinedReference13: null,
        UserDefinedReference14: null,
        UserDefinedReference15: null,
        UserDefinedReference16: null,
        UserDefinedReference17: null,
        UserDefinedReference18: null,
        UserDefinedReference19: null,
        UserDefinedReference20: null,
        WmConsigneeExpDays: null,
        Reference1: null,
        Reference2: null,
        Reference3: null,
        Reference4: null,
        Reference5: null,
        UserDefinedComment2: null,
        OversellPercentage: null,
        SaleMaxQuantity: null,
        RContainerCode: null,
        ProdCategoryDesc: null,
        ProductCategoryCode: null,
        LocationCode: null,
        WarehouseId: null,
        WarehouseName: null,
        ContainerCode: null,
        Name: null,
        CoreItemUsage: null,
        ProfileDescription: null,
        PriceCode: null,
        Description: null,
        LocationSubclassReplenishmen: null,
        ReorderQuantityEoqCalculate: null,
        ReorderQuantityOrderMultipl: null,
        WhId: null,
        Record: null,
        DisableCustomerLookup: null,
        ReceiptPutOnHold: null,
        HoldReasonCode: null,
        HoldDaysCount: null,
        LotCode: null,

    };
    const [formFields, setformFields] = useState(initialFormFields);
    const statuses = [{ id: 'A', text: 'Active' }, { id: 'I', text: 'Inactive' }];
    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length == 1) {
            rowId.current = selectedRowsData[0].RowId;
        }
        else {
            rowId.current = '';
        }

        setIsEditButtonDisabled(!isEditButtonDisabled);
    };

    const handelEditClick = () => {
        const buttonUrl = "/om/codes/item-data-entry-edit?id=" + rowId.current;
        history.push(buttonUrl);
    };

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );
    const handleSearch = (e) => {
        e.event.stopPropagation();
        loadData(formFields);
    }

    const handleReset = (e) => {
        e.event.stopPropagation();
        loadData(initialFormFields);
        setformFields(initialFormFields);
    }

    useEffect(() => {
         let datasource = loadDatasource();
         setResultData(datasource);
    }, []);

    const loadData = (fields) => {
        const filters = FillFilters(fields);
        let datasource = loadDatasource();
        datasource.filter(filters);
        setResultData(datasource);
    }
    const loadDatasource = () => {
        let store = createStore({
            key: 'RowId',
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.IM.GetItems}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });

        const dataSource = new DataSource({ store: store });
        return dataSource;
    };

    const handleFormLoad = useCallback(() => {
        loadLookupFromStaticData(formRefs, "STATUS", statuses);

    }, []);
    const loadLookupFromStaticData = (formRefs, name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'id');
            formRefs.current[name].instance().option('displayExpr', 'text');
            if (formFields[name])
                formRefs.current[name].instance().option('value', formFields[name]);
        }

    };

    const handleFieldChange = useCallback((name, value) => {
        // console.log(name, value);
    }, []);

    const [resultData, setResultData] = useState(null);


    const handleValueChanged = (e) => {
        console.log(e)
    }

    return (
        <div className="search-page-container">
            <div className="search-page-content">
                <div id="accordion" className="search-page-accordion">
                    <AccordionReact
                        dataSource={searchpanel}
                        collapsible={true}
                        multiple={false}
                        animationDuration={300}
                        selectedItems={selectedItems}
                        onSelectionChanged={e => {
                            if (e.currentTarget === e.target) {
                                selectionChanged(e, e.target);
                            }
                        }}
                        itemTitleRender={() => (
                            <Toolbar className="accordian-toolbar">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2
                                            }}
                                        >
                                            Enter Your Query For Item Data Entry
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                            </Toolbar>
                        )}
                        itemRender={(itemProps) => (
                            <FormField
                                currrentUser={currentUser}
                                layoutId='1E58A628-DCE1-43E6-A46A-F6D1B4D51BFF'
                                layoutName='WMItemDataEntrySearchForm'
                                defaultFormSchema={SearchLayout}
                                formFields={formFields}
                                setformFields={setformFields}
                                handleFieldValueChange={handleFieldChange}
                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                formRefs={formRefs}
                                onFormLoad={handleFormLoad}
                                noSpacingBeforeFirstRow={true}
                            />
                        )}
                        id="accordion-container" className="accordion-height"
                    />
                </div>
                <div className="search-page-grid-container">
                    <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                        ref={dataGrid}
                        allowColumnReordering={true}
                        allowColumnResizing={true}
                        dataSource={resultData}
                        showBorders={true}
                        hoverStateEnabled={true}
                        className="search-page-grid"
                            onSelectionChanged={(e) => onSelectionChanged(e)}
                            remoteOperations={true}
                            searchEnabled={true}
                            columnAutoWidth={true}
                        >
                            <ColumnChooser
                                enabled={true}
                                title="Choose Column"
                                width={290}
                                height={290}
                                sortOrder="asc"
                            >
                                <ColumnChooserSearch
                                    enabled={true}
                                    editorOptions={{ placeholder: 'Search column' }} />
                            </ColumnChooser>
                            <Export enabled={true} allowExportSelectedData={true} />
                            <Selection mode="multiple" />
                            <Sorting visible={true} mode="multiple" />
                            <Paging defaultPageSize={10} />
                            <Pager
                                visible={true}
                                showPageSizeSelector={true}
                                allowedPageSizes={allowedPageSizes}
                                showNavigationButtons={true}
                            />
                            <FilterRow visible={true} />
                            <FilterPanel visible={true} />
                            <GroupPanel visible={true} />
                            <Grouping autoExpandAll={false} />
                            <StateStoring
                                enabled={true}
                                type="custom"
                                customLoad={loadState}
                                storageKey={gridKey}
                                customSave={saveState}
                            />
                            <FilterRow visible={true} />
                            <Column dataType="string" caption='WH' dataField='WhId' />
                            <Column dataType="string" caption='Item' dataField='ItemCode' />
                            <Column dataType="string" caption='Item Type' dataField='ItemType' >
                                <Lookup
                                    dataSource={[{ id: 'I', text: 'Item' }, { id: 'L', text: 'Item/Lot' }, { id: 'S', text: 'Item/Lot/Sublot' }, { id: 'U', text: 'Item/Lot/Sublot/Uni' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column dataType="string" caption='Description - 1' dataField='Description1' />
                            <Column dataType="string" caption='Description - 2' dataField='Description2' />
                            <Column dataType="string" caption='Class' dataField='ClassCode' />
                            <Column dataType="string" caption='Sub Class' dataField='SubClassCode' />
                            <Column dataType="string" caption='Status' dataField='Status' >
                                <Lookup
                                    dataSource={[{ id: 'A', text: 'Active' }, { id: 'I', text: 'Inactive' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>

                            <Column visible={false} dataType="datetime" caption='Creation Date' dataField='CreationDateTime' />
                            <Column visible={false} dataType="string" caption='Created By' dataField='CreationUserId' />
                            <Column visible={false} dataType="datetime" caption='Last Updated' dataField='LastUpdateDateTime' />
                            <Column visible={false} dataType="string" caption='Last Updated By' dataField='LastUpdateUserId' />

                            <Column visible={false} dataType="string" caption='OEM Code' dataField='OemManufacturerCode' />
                            <Column visible={false} dataType="string" caption='Record #' dataField='Record' />
                            <Column visible={false} dataType="string" caption='ABC Code' dataField='AbcCode' />

                            <Column visible={false} dataType="string" caption='Reason Code' dataField='StatusReasonCode' />
                            <Column visible={false} dataType="string" caption='Tax Status' dataField='TaxStatus' >
                                <Lookup
                                    dataSource={[{ id: 'Y', text: 'Yes' }, { id: 'N', text: 'No' }, { id: 'A', text: 'Always Taxable' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Freight Class' dataField='FreightClassCode' />
                            <Column visible={false} dataType="string" caption='Count Cycle' dataField='PhysicalCountCode' />
                            <Column visible={false} dataType="string" caption='Inventory Unit' dataField='InventoryUnitUom' />
                            <Column visible={false} dataType="string" caption='Unit Net Wt' dataField='NetWeightQuantity' />
                            <Column visible={false} dataType="string" caption='Unit Gross Wt' dataField='GrossWeightQuantity' />
                            <Column visible={false} dataType="string" caption='Receipt Pack & Size' dataField='ReceiptPackSize' />
                            <Column visible={false} dataType="string" caption='Box Code' dataField='BoxCode' />
                            <Column visible={false} dataType="string" caption='Hazardous ' dataField='HazardousFlag' >
                                <Lookup
                                    dataSource={[{ id: 'N', text: 'No' }, { id: 'A', text: 'Yes' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Instructions' dataField='CareInstructions' />
                            <Column visible={false} dataType="string" caption='Specifications' dataField='SpecificationCode' />
                            <Column visible={false} dataType="string" caption='Alternate SKU' dataField='ItemSupcCode' />
                            <Column visible={false} dataType="string" caption='IM Kit Flag' dataField='BomExplosionFlag' >
                                <Lookup
                                    dataSource={[{ id: 'N', text: 'Not Used' }, { id: 'M', text: 'Update Kit Item Quantities, during Commit of IM Receipts only' }, { id: 'I', text: 'Access Kit Details From IM Transactions According To IM Profile' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='OM Kit Flag' dataField='OmKitFlag' >
                                <Lookup
                                    dataSource={[{ id: 'N', text: 'Not Used' }, { id: 'S', text: 'Auto-explode kit inputs in OM when entered' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>

                            <Column visible={false} dataType="datetime" caption='Introduced Dt' dataField='DateIntroduced' />
                            <Column visible={false} dataType="datetime" caption='Available Dt' dataField='DateAvailable' />
                            <Column visible={false} dataType="datetime" caption='Expiration Dt' dataField='DateExpiration' />
                            <Column visible={false} dataType="string" caption='Item Source' dataField='ItemSourceFlag' >
                                <Lookup
                                    dataSource={[{ id: 'M', text: 'Manufactured' }, { id: 'P', text: 'Purchased' }, { id: 'O', text: 'Manufactured & Ordered' }, { id: 'R', text: 'Purchased & Ordered' }, { id: 'B', text: 'Brokered' }, { id: 'D', text: 'Drop-Ship' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Method' dataField='ReorderMethodFlag' >
                                <Lookup
                                    dataSource={[{ id: 'N', text: 'Not Applicable' }, { id: 'M', text: 'Based on Min-Max Quantities' }, { id: 'P', text: 'Based on Min with Preset Order Quantity' }, { id: 'L', text: 'Lot Level' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>

                            <Column visible={false} dataType="string" caption='Minimum Qty' dataField='ReorderInventoryMinimumQty' />
                            <Column visible={false} dataType="string" caption='Maximum Qty' dataField='ReorderInventoryMaximumQty' />
                            <Column visible={false} dataType="string" caption='Calculated Qty' dataField='ReorderQuantityEoqCalculated' />
                            <Column visible={false} dataType="string" caption='Entered Qty' dataField='ReorderQuantityEntered' />
                            <Column visible={false} dataType="string" caption='Order Multiple' dataField='ReorderQuantityOrderMultiple' />
                            <Column visible={false} dataType="string" caption='Safety Qty' dataField='ReorderSafetyQuantity' />
                            <Column visible={false} dataType="string" caption='Cost Basis' dataField='CostBasisMethodFlag' >
                                <Lookup
                                    dataSource={[{ id: 'S', text: 'Standard Cost' }, { id: 'A', text: 'Average Cost' }, { id: 'L', text: 'Last Cost' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Average Cost' dataField='AverageCost' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Standard Cost' dataField='StandardCost' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Core Price' dataField='CorePrice' />
                            <Column visible={false} dataType="string" caption='Code 1' dataField='UserDefinedCode1' />
                            <Column visible={false} dataType="string" caption='Code 3' dataField='UserDefinedCode3' />
                            <Column visible={false} dataType="string" caption='Code 4' dataField='UserDefinedCode4' />
                            <Column visible={false} dataType="string" caption='Code 5' dataField='UserDefinedCode5' />
                            <Column visible={false} dataType="string" caption='Code 6' dataField='UserDefinedCode6' />
                            <Column visible={false} dataType="string" caption='Code 7' dataField='UserDefinedCode7' />
                            <Column visible={false} dataType="string" caption='Code 8' dataField='UserDefinedCode8' />
                            <Column visible={false} dataType="string" caption='Code 2' dataField='UserDefinedCode2' />
                            <Column visible={false} dataType="string" caption='Code 9' dataField='UserDefinedCode9' />
                            <Column visible={false} dataType="string" caption='Code 10' dataField='UserDefinedCode10' />
                            <Column visible={false} dataType="string" caption='Reference 1' dataField='UserDefinedReference1' />
                            <Column visible={false} dataType="string" caption='Reference 2' dataField='UserDefinedReference2' />
                            <Column visible={false} dataType="string" caption='Reference 3' dataField='UserDefinedReference3' />
                            <Column visible={false} dataType="string" caption='Reference 4' dataField='UserDefinedReference4' />
                            <Column visible={false} dataType="string" caption='Reference 5' dataField='UserDefinedReference5' />
                            <Column visible={false} dataType="string" caption='Reference 6' dataField='UserDefinedReference6' />
                            <Column visible={false} dataType="string" caption='Reference 7' dataField='UserDefinedReference7' />
                            <Column visible={false} dataType="string" caption='Reference 8' dataField='UserDefinedReference8' />
                            <Column visible={false} dataType="string" caption='Reference 9' dataField='UserDefinedReference9' />
                            <Column visible={false} dataType="string" caption='Reference 10' dataField='UserDefinedReference10' />
                            <Column visible={false} dataType="datetime" caption='Date 1' dataField='UserDefinedDate1' />
                            <Column visible={false} dataType="datetime" caption='Date 2' dataField='UserDefinedDate2' />
                            <Column visible={false} dataType="datetime" caption='Date 3' dataField='UserDefinedDate3' />
                            <Column visible={false} dataType="datetime" caption='Date 4' dataField='UserDefinedDate4' />
                            <Column visible={false} dataType="datetime" caption='Date 5' dataField='UserDefinedDate5' />
                            <Column visible={false} dataType="datetime" caption='Date 6' dataField='UserDefinedDate6' />
                            <Column visible={false} dataType="datetime" caption='Date 7' dataField='UserDefinedDate7' />
                            <Column visible={false} dataType="datetime" caption='Date 8' dataField='UserDefinedDate8' />
                            <Column visible={false} dataType="datetime" caption='Date 9' dataField='UserDefinedDate9' />
                            <Column visible={false} dataType="datetime" caption='Date 10' dataField='UserDefinedDate10' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 1' dataField='UserDefinedQuantity1' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 2' dataField='UserDefinedQuantity2' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 3' dataField='UserDefinedQuantity3' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 4' dataField='UserDefinedQuantity4' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 5' dataField='UserDefinedQuantity5' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 6' dataField='UserDefinedQuantity6' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 7' dataField='UserDefinedQuantity7' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 8' dataField='UserDefinedQuantity8' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 9' dataField='UserDefinedQuantity9' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 10' dataField='UserDefinedQuantity10' />
                            <Column visible={false} dataType="string" caption='Name' dataField='Name' />
                            <Column visible={false} dataType="string" caption='Vendor Item ' dataField='VendorItemCode' />
                            <Column visible={false} dataType="string" caption='Trade Disc' dataField='ArTradeDiscountFlag' >
                                <Lookup
                                    dataSource={[{ id: 'Y', text: 'Yes, Apply Customer Discount' }, { id: 'N', text: 'No' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='AR Terms Disc' dataField='ArTermsDiscountFlag' >
                                <Lookup
                                    dataSource={[{ id: 'Y', text: 'Yes, Apply Customer Terms Discount' }, { id: 'N', text: 'No' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Sales Multiple' dataField='SaleIncrementQuantity' />
                            <Column visible={false} dataType="string" caption='Min Sales Qty' dataField='MinimumSalesQuantity' />
                            <Column visible={false} dataType="string" caption='Class' dataField='LocationClassForwardPick' />
                            <Column visible={false} dataType="string" caption='Location Class Replenishment' dataField='LocationClassReplenishment' />
                            <Column visible={false} dataType="string" caption='Location Class Reserve' dataField='LocationClassReserve' />
                            <Column visible={false} dataType="string" caption='Subclass' dataField='LocationSubclassForwardPick' />
                            <Column visible={false} dataType="string" caption='Location Subclass Replenishment' dataField='LocationSubclassReplenishment' />
                            <Column visible={false} dataType="string" caption='Location Subclass Reserve' dataField='LocationSubclassReserve' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Maximum Units' dataField='LocationMaxUnitsForwardPick' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Minimum Units' dataField='LocationMinUnitsForwardPick' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Pending Rec' dataField='InOrdered' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='In Receiving' dataField='InReceiving' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='In Shipping' dataField='OutShipped' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='BO Receiving' dataField='InBackOrder' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='BO Shipping' dataField='OutBackOrder' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Unavailable' dataField='OutUnavailable' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Future Rec' dataField='InFuture' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Future Ship' dataField='OutFuture' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Available' dataField='Available' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Net Available' dataField='NetAvailable' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Last Cost' dataField='LastCost' />
                            <Column visible={false} dataType="string" caption='Inventory Source' dataField='InventoryQuantitySource' >
                                <Lookup
                                    dataSource={[{ id: 'I', text: 'Item' }, { id: 'L', text: 'Lot' }, { id: 'S', text: 'Sublot' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Rate Source' dataField='RateSource' >
                                <Lookup
                                    dataSource={[{ id: 'I', text: 'Item' }, { id: 'L', text: 'Lot' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Rate Selection' dataField='RateSelection' >
                                <Lookup
                                    dataSource={[{ id: 'N', text: 'Show All Rate Schedules' }, { id: 'C', text: 'Filter By Customer' }, { id: 'L', text: 'Filter By Customer/Class' }, { id: 'S', text: 'Filter By Customer/Class/Sub Class' }, { id: 'U', text: 'Filter By Class' }, { id: 'V', text: 'Filter By Sub Class' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Prod Category' dataField='ProductCategoryCode' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Size - 1' dataField='Size1' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Size - 2' dataField='Size2' />
                            <Column visible={false} dataType="string" caption='Mgmt Source' dataField='ManagementSource' >
                                <Lookup
                                    dataSource={[{ id: 'I', text: 'Item' }, { id: 'L', text: 'Lot' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Sublot Unique' dataField='SublotUniqueFlag' >
                                <Lookup
                                    dataSource={[{ id: 'N', text: 'Not Applicable' }, { id: 'Y', text: 'All Sublots Created Will Be Assumed To Be Unique & Always Have a Quantity Of One' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Profile' dataField='ProfileCode' />
                            <Column visible={false} dataType="string" caption='Profile Description' dataField='ProfileDescription' />
                            <Column visible={false} dataType="string" caption='First Receipt' dataField='InTransactionNumber' />
                            <Column visible={false} dataType="datetime" caption='Last Receipt Dt' dataField='DateLastReceipt' />
                            <Column visible={false} dataType="string" caption='Item' dataField='ItemPayGroup' />
                            <Column visible={false} dataType="string" caption='Recurring Flag' dataField='RecurringStorage' >
                                <Lookup
                                    dataSource={[{ id: 'Y', text: 'Yes, Always Generate Recurring Storage Charges' }, { id: 'N', text: 'No, Never Generate Recurring Storage Charges' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Accessibility' dataField='WebAccessibility' >
                                <Lookup
                                    dataSource={[{ id: 'A', text: 'Accessible to both salespeople and customers' }, { id: 'S', text: 'Accessible only to salespeople' }, { id: 'C', text: 'Accessible only to customers' }, { id: 'N', text: 'Not accessible' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='PM Kit Flag' dataField='PmKitFlag' >
                                <Lookup
                                    dataSource={[{ id: 'A', text: 'Not Used' }, { id: 'B', text: 'Production Item' }, { id: 'C', text: 'Alternate Production Item' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>

                            <Column visible={false} dataType="string" caption='Source' dataField='WarrantyFlagShipment' >
                                <Lookup
                                    dataSource={[{ id: 'N', text: 'Not Applicable' }, { id: 'I', text: 'Use Item Expiration Date' }, { id: 'L', text: 'Use Lot Expiration Date' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Chk Max Days' dataField='CheckMaxDays' >
                                <Lookup
                                    dataSource={[{ id: '1', text: 'No' }, { id: '2', text: 'Yes, check but allow override' }, { id: '3', text: 'Yes, check but never allow override' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Check Lot Exp' dataField='CheckLotExpiration' >
                                <Lookup
                                    dataSource={[{ id: 'Y', text: 'Yes' }, { id: 'N', text: 'No' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Price Code' dataField='PriceCode' />
                            <Column visible={false} dataType="string" caption='Qty Auto Update' dataField='AutomaticallyUpdateQuantity' >
                                <Lookup
                                    dataSource={[{ id: 'N', text: 'No, Not Applicable' }, { id: 'U', text: 'Yes, Update Units as Quantity' }, { id: 'W', text: 'Yes, Update Weight as Quantity' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Update UOM Wt' dataField='UpdateUomWeight' >
                                <Lookup
                                    dataSource={[{ id: 'Y', text: 'Yes, Update Average Weights Based on Serial #39' }, { id: 'N', text: 'No, Not Applicable' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Available' dataField='LocationAvailableDefault' >
                                <Lookup
                                    dataSource={[{ id: 'Y', text: 'Yes, Available' }, { id: 'N', text: 'No, Not Available' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Reason Code' dataField='LocationReasonCodeDefault' />
                            <Column visible={false} dataType="string" caption='Item Group' dataField='RItemGroup' />
                            <Column visible={false} dataType="string" caption='Item Sub Group' dataField='ItemSubGroup' />
                            <Column visible={false} dataType="string" caption='Item Member' dataField='ItemMember' />
                            <Column visible={false} dataType="string" caption='Chk Rec Days' dataField='CheckReceiptDays' >
                                <Lookup
                                    dataSource={[{ id: '1', text: 'No expiration days checking' }, { id: '2', text: 'Check days and allow to continue' }, { id: '3', text: 'Check days and do not allow to continue' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Chk Ship Days' dataField='CheckShipmentDays' >
                                <Lookup
                                    dataSource={[{ id: '1', text: 'No expiration days checking' }, { id: '2', text: 'Check days and allow to continue' }, { id: '3', text: 'Check days and do not allow to continue' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Mandated Fees' dataField='RImMandatedFees' />
                            <Column visible={false} dataType="string" caption='Based on' dataField='ExpDateBasedOn' >
                                <Lookup
                                    dataSource={[{ id: 'N', text: 'None' }, { id: 'A', text: 'Receive/Ship date of Receipt' }, { id: 'B', text: 'Lot Code as Truncated JD of Receipt' }, { id: 'C', text: 'Lot Code as Modified JD of Receipt' }, { id: 'D', text: 'Lot Code as Julian Day of Receipt' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Add Days' dataField='AddToExpDate' />
                            <Column visible={false} dataType="string" caption='Code 11' dataField='UserDefinedCode11' />
                            <Column visible={false} dataType="string" caption='Code 12' dataField='UserDefinedCode12' />
                            <Column visible={false} dataType="string" caption='Code 13' dataField='UserDefinedCode13' />
                            <Column visible={false} dataType="string" caption='Code 14' dataField='UserDefinedCode14' />
                            <Column visible={false} dataType="string" caption='Code 15' dataField='UserDefinedCode15' />
                            <Column visible={false} dataType="string" caption='Code 16' dataField='UserDefinedCode16' />
                            <Column visible={false} dataType="string" caption='Code 17' dataField='UserDefinedCode17' />
                            <Column visible={false} dataType="string" caption='Code 18' dataField='UserDefinedCode18' />
                            <Column visible={false} dataType="string" caption='Code 19' dataField='UserDefinedCode19' />
                            <Column visible={false} dataType="string" caption='Code 20' dataField='UserDefinedCode20' />
                            <Column visible={false} dataType="string" caption='Reference 11' dataField='UserDefinedReference11' />
                            <Column visible={false} dataType="string" caption='Reference 12' dataField='UserDefinedReference12' />
                            <Column visible={false} dataType="string" caption='Reference 13' dataField='UserDefinedReference13' />
                            <Column visible={false} dataType="string" caption='Reference 14' dataField='UserDefinedReference14' />
                            <Column visible={false} dataType="string" caption='Reference 15' dataField='UserDefinedReference15' />
                            <Column visible={false} dataType="string" caption='Reference 16' dataField='UserDefinedReference16' />
                            <Column visible={false} dataType="string" caption='Reference 17' dataField='UserDefinedReference17' />
                            <Column visible={false} dataType="string" caption='Reference 18' dataField='UserDefinedReference18' />
                            <Column visible={false} dataType="string" caption='Reference 19' dataField='UserDefinedReference19' />
                            <Column visible={false} dataType="string" caption='Reference 20' dataField='UserDefinedReference20' />
                            <Column visible={false} dataType="datetime" caption='Date 11' dataField='UserDefinedDate11' />
                            <Column visible={false} dataType="datetime" caption='Date 12' dataField='UserDefinedDate12' />
                            <Column visible={false} dataType="datetime" caption='Date 13' dataField='UserDefinedDate13' />
                            <Column visible={false} dataType="datetime" caption='Date 14' dataField='UserDefinedDate14' />
                            <Column visible={false} dataType="datetime" caption='Date 15' dataField='UserDefinedDate15' />
                            <Column visible={false} dataType="datetime" caption='Date 16' dataField='UserDefinedDate16' />
                            <Column visible={false} dataType="datetime" caption='Date 17' dataField='UserDefinedDate17' />
                            <Column visible={false} dataType="datetime" caption='Date 18' dataField='UserDefinedDate18' />
                            <Column visible={false} dataType="datetime" caption='Date 19' dataField='UserDefinedDate19' />
                            <Column visible={false} dataType="datetime" caption='Date 20' dataField='UserDefinedDate20' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 11' dataField='UserDefinedQuantity11' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 12' dataField='UserDefinedQuantity12' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 13' dataField='UserDefinedQuantity13' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 14' dataField='UserDefinedQuantity14' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 15' dataField='UserDefinedQuantity15' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 16' dataField='UserDefinedQuantity16' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 17' dataField='UserDefinedQuantity17' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 18' dataField='UserDefinedQuantity18' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 19' dataField='UserDefinedQuantity19' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Quantity 20' dataField='UserDefinedQuantity20' />
                            <Column visible={false} dataType="string" caption='Consignee Adj Days' dataField='WmConsigneeExpDays' >
                                <Lookup
                                    dataSource={[{ id: 'Y', text: 'Adjust Expiration Days by Consignee' }, { id: 'N', text: 'Do Not Adjust Expiration Days by Consignee' }]}
                                    displayExpr="text"
                                    valueExpr="id" />
                            </Column>
                            <Column visible={false} dataType="string" caption='Item Ref 1' dataField='Reference1' />
                            <Column visible={false} dataType="string" caption='Item Ref 2' dataField='Reference2' />
                            <Column visible={false} dataType="string" caption='Item Ref 3' dataField='Reference3' />
                            <Column visible={false} dataType="string" caption='Item Ref 4' dataField='Reference4' />
                            <Column visible={false} dataType="string" caption='Item Ref 5' dataField='Reference5' />
                            <Column visible={false} dataType="string" caption='Oversell %' dataField='OversellPercentage' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Sale Max Qty' dataField='SaleMaxQuantity' />
                            <Column visible={false} dataType="string" caption='Container Code' dataField='ContainerCode' />
                            <Column visible={false} dataType="string" caption='Description' dataField='Description' />

                            <GridToolbar>
                                <GridToolbarItem location="before">
                                    <Button
                                        disabled={isEditButtonDisabled}
                                        onClick={handelEditClick}
                                        type="default"
                                        text="Edit"
                                    ></Button>
                                </GridToolbarItem>
                                <GridToolbarItem location="before">
                                    <div>
                                        <Link to="/om/codes/item-data-entry-create">
                                            <Button
                                                type="default"
                                                className="gridTopButton"
                                                text="Create"
                                            ></Button>
                                        </Link>
                                    </div>
                                </GridToolbarItem>
                                <GridToolbarItem location="after">
                                    <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                                </GridToolbarItem>
                                <GridToolbarItem name="exportButton" />
                                <GridToolbarItem name="columnChooserButton" />
                            </GridToolbar>
                    </DataGrid>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}
export default connect(mapStateToProps)(List);